import ViewComponentsRenderer from "../../../../components/campaign/viewComponents/ViewComponentsRenderer";
import SummaryCard from "./SummaryCard";

export default function CampaignRulesSummary({
  campaignRules = [],
  isViewScreen,
  handleOutcomesEditSection,
}) {
  return (
    <SummaryCard
      title="Campaign Setup - Rules"
      isViewScreen={isViewScreen}
      handleEditSection={handleOutcomesEditSection}
    >
      {campaignRules?.map((rule, i) => (
        <ViewComponentsRenderer
          data={rule.ruleData}
          inputSchema={rule.ruleDefinition?.inputSchema}
          customComponentName={rule.ruleDefinition?.slug}
          uiSchema={rule.ruleDefinition?.uiSchema || {}}
          key={rule.ruleDefinition?.slug + i + JSON.stringify(rule.ruleData)}
          ruleDefinition={rule.ruleDefinition}
        />
      ))}
    </SummaryCard>
  );
}
